var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPage)?_c('div',{staticClass:"signature-third"},[(_vm.isSignature)?[_c('signature-modal',{attrs:{"pageFrom":_vm.pageFrom},on:{"saveSignature":_vm.handleBase64}})]:[_c('attention',{attrs:{"codeStatus":_vm.codeStatus}})]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }